import { render, staticRenderFns } from "./FacturaDialog.vue?vue&type=template&id=4442bb88&scoped=true"
import script from "./FacturaDialog.vue?vue&type=script&lang=js"
export * from "./FacturaDialog.vue?vue&type=script&lang=js"
import style0 from "./FacturaDialog.vue?vue&type=style&index=0&id=4442bb88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4442bb88",
  null
  
)

export default component.exports